<template>
  <div :class="['relative', 'bg_linear_to_r']">
    <div :class="['bg-default/10', 'z-1', 'text-white']">
      <!-- 实际内容容器 -->
      <div :class="['flex items-center justify-between lg:gap-2 gap-1', 'page_view']">
        <!-- 窄屏下的新闻卡片组-轮播图，此处不用v-for循环 -->
        <UCarousel
          v-slot="{ item }"
          :items="newsArticleList"
          orientation="vertical"
          loop
          :watch-drag="false"
          :autoplay="{
            delay: 3000,
            stopOnInteraction: false,
          }"
          :ui="{
            root: 'overflow-hidden',
            viewport: 'overflow-hidden',
            // ❗轮播图竖向需要设置固定高度，高度需要手动对照插槽中容器高度修改
            container: 'h-6 mt-0',
            item: ['flex items-center justify-start', 'text-md', 'pt-0 size-full'],
            controls: 'flex',
            arrows: '',
            prev: '',
            next: '',
            dots: '',
            dot: '',
          }"
        >
          <!-- 前缀容器 -->
          <div :class="['flex items-center', 'gap-x-1 overflow-hidden text-nowrap']">
            <div :class="['flex justify-center items-center gap-x-1']">
              <UIcon name="gravity-ui:volume-fill" />
              <p>{{ t('placeholder.news') }}:</p>
            </div>
            <!-- 新闻标题 -->
            <p
              :class="['hover:underline hover:cursor-pointer', 'truncate']"
              @click="useLocalePush(`${item.path}`)"
            >
              {{ item.title }}
            </p>
          </div>
        </UCarousel>
        <!-- 右侧按钮 -->
        <UButton
          trailing-icon="fe:arrow-right"
          :ui="{ base: ['hover:shadow-xl'] }"
          @click="useLocalePush('/about/news')"
        >
          {{ t('action.learnMore') }}
        </UButton>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  const { t } = useI18n()

  // 获取新闻类文章元数据列表
  const { getArticleListByStem } = useI18nContent()
  const newsArticleList = await getArticleListByStem()
</script>
